<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div class="d-flex justify-content-between align-items-center">
            <h4>Nhóm</h4>
            <el-button
              class="btn-back"
              @click="fn_goBack"
              >Quay lại</el-button
            >
          </div>
          <div class="main-body mt-2">
            <div class="main-body-search">
              <!-- Start add Group -->
              <el-card class="box-card mb-3">
                <el-form
                  ref="formCreateDocGroup"
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  @submit.native.prevent
                  label-width="145px"
                >
                  <b-row class="mb-3">
                    <h5>Thêm mới nhóm</h5>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="12">
                      <el-form-item label="Tên nhóm" prop="name">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.name"
                          placeholder=""
                          clearable
                          ref="name"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="12">
                      <!-- <el-form-item label="Thành viên">
                        <el-select
                          v-model="membersGroup"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                          filterable
                          placeholder="Nhập từ khóa (nhấn Enter để tìm kiếm)"
                          no-data-text="Chưa có dữ liệu"
                          :filter-method="fn_remoteGetListMemberGroup"
                          @keyup.enter.native="fn_findListByType('people')"
                          @change="fn_addPerson(membersGroup)"
                        >
                          <el-option
                            v-for="item in listMemberGroup"
                            :key="item.id"
                            :label="fn_setLabelRespectively(item)"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item> -->
                      <el-form-item
                        label="Thành viên"
                        prop=""
                      >
                        <el-select
                          filterable
                          v-model="membersGroup"
                          @change="fn_addMember(membersGroup)"
                        >
                          <el-option
                            v-for="item in mData.listEmployee"
                            :key="item.id"
                            :label="fn_setLabelRespectively(item)"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col
                      md="12"
                      class="mb-3"
                      v-if="listMemberGroupTable.length > 0"
                    >
                      <p class="mb-2">Danh sách thành viên nhóm</p>
                      <el-table :data="listMemberGroupTable" border>
                        <el-table-column
                          type="index"
                          width="50"
                          label="STT"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          label="Họ và tên"
                          prop="administrative_info.name.full_name"
                          min-width="200"
                        >
                          <template slot-scope="scope">
                            <el-popover
                              placement="top-start"
                              trigger="hover"
                              :open-delay="800"
                              :content="
                                scope.row.administrative_info.name.full_name
                                  ? scope.row.administrative_info.name.full_name
                                  : ''
                              "
                            >
                              <span class="content" slot="reference">{{
                                scope.row.administrative_info.name.full_name
                                  ? scope.row.administrative_info.name.full_name
                                  : ""
                              }}</span>
                            </el-popover>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="Chức vụ"
                          prop="job_info[0].position_name"
                          align="center"
                        >
                          <template slot-scope="scope">
                            <el-popover
                              placement="top-start"
                              trigger="hover"
                              :open-delay="800"
                              :content="
                                scope.row.job_info[0].position_name
                                  ? scope.row.job_info[0].position_name
                                  : ''
                              "
                            >
                              <span class="content" slot="reference">{{
                                scope.row.job_info[0].position_name
                                  ? scope.row.job_info[0].position_name
                                  : ""
                              }}</span>
                            </el-popover>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="Đơn vị"
                          prop="job_info[0].department_name"
                          align="center"
                        >
                          <template slot-scope="scope">
                            <el-popover
                              placement="top-start"
                              trigger="hover"
                              :open-delay="800"
                              :content="
                                scope.row.job_info[0].department_name
                                  ? scope.row.job_info[0].department_name
                                  : ''
                              "
                            >
                              <span class="content" slot="reference">{{
                                scope.row.job_info[0].department_name
                                  ? scope.row.job_info[0].department_name
                                  : ""
                              }}</span>
                            </el-popover>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="Thao tác"
                          width="80"
                          align="center"
                          v-if="mData.viewMode != 'detail'"
                        >
                          <template slot-scope="scope">
                            <i
                              class="icon isax-trash"
                              @click="fn_deleteMember(scope.row.id)"
                              v-b-popover.hover.left="aLang.c_delete"
                            ></i>
                          </template>
                        </el-table-column>
                      </el-table>
                    </b-col>
                  </b-row>
                  <div class="text-center mb-0">
                    <el-button
                      v-if="viewMode == 'create'"
                      class="btn-default"
                      @click="fn_submitForm('create')"
                      >Lưu</el-button
                    >
                    <el-button
                      v-if="viewMode == 'update'"
                      class="btn-default"
                      @click="fn_submitForm('update')"
                      >Cập nhật</el-button
                    >
                    <el-button
                      v-if="viewMode == 'update'"
                      class="btn-back"
                      @click="fn_cancelUpdate()"
                      >Hủy</el-button
                    >
                  </div>
                </el-form>
              </el-card>
              <!-- End add Group -->

              <!-- Group Table -->
              <h5 class="mb-1">Danh mục nhóm</h5>
              <div class="main-body-table">
                <el-table
                  :data="mData.tableRules.data"
                  border
                  style="width: 100%"
                >
                  <el-table-column prop="" label="STT" width="45">
                    <template slot-scope="scope">
                      <div class="text-center">
                        {{ mData.tableRules.offset + scope.$index + 1 }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="Tên nhóm"
                    min-width="200"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        trigger="hover"
                        :open-delay="800"
                        :content="scope.row.name"
                      >
                        <span class="content" slot="reference">{{
                          scope.row.name
                        }}</span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="list_user"
                    label="Thành viên"
                    min-width="300"
                  >
                    <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        trigger="hover"
                        :open-delay="800"
                        :content="scope.row.list_user.length > 0 ? scope.row.list_user : ''"
                      >
                        <span class="content" slot="reference">{{
                          scope.row.list_user.length > 0 ? scope.row.list_user : ''
                        }}</span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="Thao tác" align="center">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        plain
                        round
                        @click="fn_handle('update', scope.$index, scope.row)"
                        v-b-popover.hover.left="aLang.c_update"
                        type="primary"
                        :disabled="scope.row.is_default"
                      >
                        <i class="far fa-edit"></i>
                      </el-button>
                      <el-button
                        size="mini"
                        plain
                        round
                        @click="fn_handle('delete', scope.$index, scope.row)"
                        v-b-popover.hover.left="aLang.c_delete"
                        type="danger"
                        :disabled="scope.row.is_default"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
                  <div class="col-md-4">
                    <!-- <div v-if="mData.tableRules.allowSelect">
                      {{ aLang.c_select }}:
                      {{ mData.tableRules.recordSelected.length }}
                    </div> -->
                  </div>
                  <div class="col-md-8 text-right">
                    <el-pagination
                      @size-change="fn_tableSizeChange"
                      @current-change="fn_tableCurentChange"
                      @prev-click="fn_tablePrevClick"
                      @next-click="fn_tableNextClick"
                      :page-sizes="mData.tableRules.lengthMenu"
                      :page-size="mData.tableRules.limit"
                      :current-page="mData.tableRules.page"
                      background
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="mData.tableRules.total"
                      :pager-count="5"
                    ></el-pagination>
                  </div>
                </b-row>
              </div>
              <!-- Group Table -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import CategoryManagementModel from "./CategoryManagementModel";
import DocumentGroupApi from "../../../moduleApi/DocumentGroupApi";
import DepartmentApi from "../../../moduleApi/DepartmentApi";
import PositionApi from "../../../moduleApi/PositionApi";
import EmployeeApi from "../../../moduleApi/EmployeeApi";
import { dataMixin } from './mixin/dataMixin'
import { functionMixin } from './mixin/functionMixin'

export default {
  mixins: [dataMixin, functionMixin],
  data() {
    return {
      aLang: LanguageService.lang,
      viewMode: "create",
      membersGroup: "",
      textFindPeople: "",
      listMemberGroup: [],
      listMemberGroupTable: [],
      mData: {
        moduleName: "DocumentGroup",
        tableRules: MethodService.copyObject(
          CategoryManagementModel.tableRules
        ),
        dataForm: MethodService.copyObject(
          CategoryManagementModel.dataFormDocGroup
        ),
        validForm: CategoryManagementModel.validFormDocGroup,
        dataDefault: {
          listPosition: [],
          listDepartment: [],
        },
        listEmployee: [],
      },
    };
  },
  methods: {
    async fn_getListEmployee() {
      const employeeApiRes = await EmployeeApi.list({
        filters: `status!=DA_NGHI`,
        fields: "id,administrative_info,employee_no,job_info,status",
        limit: 9999,
      });
      if (employeeApiRes.result) {
        this.mData.listEmployee = employeeApiRes.result;
      }
    },

    async fn_getListPosition() {
      const positionApiRes = await PositionApi.list({
        fields: 'name',
        limit: 9999
      });
      if (positionApiRes.result) {
        this.mData.dataDefault.listPosition = positionApiRes.result;
      }
    },

    async fn_getListDepartment() {
      const departmentApiRes = await DepartmentApi.list({
        fields: 'name',
        limit: 9999
      });
      if (departmentApiRes.result) {
        this.mData.dataDefault.listDepartment = departmentApiRes.result;
      }
    },

    fn_setLabelRespectively(item) {
      return `${item.employee_no ? item.employee_no : ""} - ${
        item.administrative_info.name.full_name
          ? item.administrative_info.name.full_name
          : ""
      }`;
    },

    async fn_remoteGetListMemberGroup(query) {
      this.textFindPeople = query;
      this.listMemberGroup = [];
    },

    async fn_findListByType(type) {
      if (type == "people") {
        const employeeApiRes = await EmployeeApi.list({
          limit: 1000,
          fields: "id,administrative_info,employee_no,job_info",
          filters: this.textFindPeople
            ? `administrative_info.name.full_name:regex_i:${this.textFindPeople}`
            : "",
        });
        if (employeeApiRes.result && employeeApiRes.result.length > 0) {
          this.listMemberGroup = employeeApiRes.result;
        }
        this.textFindPeople = "";
      }
    },

    async fn_getEmployeeById(id) {
      const employeeApiRes = await EmployeeApi.findById(id);
      if (employeeApiRes.result) {
        this.personSelected = await this.fn_changeData(employeeApiRes.result);
        this.personSelected.status = false;
      }
    },

    async fn_changeData(resData) {
      if (resData.job_info[0].position_id) {
        const positionApiRes = await PositionApi.findById(
          resData.job_info[0].position_id
        );
        if (positionApiRes.result) {
          resData.job_info[0].position_name = positionApiRes.result.name;
        }
      }
      if (resData.job_info[0].department_id) {
        const departmentApiRes = await DepartmentApi.findById(
          resData.job_info[0].department_id
        );
        if (departmentApiRes.result) {
          resData.job_info[0].department_name = departmentApiRes.result.name;
        }
      }
      return resData;
    },

    async fn_addPerson(item) {
      if (item) {
        let flag = null;
        flag = this.listMemberGroupTable.find((person) => person.id == item);
        if (flag) {
          window.toastr.warning(`Đã tồn tại người này trong nhóm`);
          return;
        } else {
          await this.fn_getEmployeeById(item);
          this.listMemberGroupTable.push(this.personSelected);
          this.membersGroup = null;
          this.listMemberGroup = [];
          // console.log("listMemberGroupTable", this.listMemberGroupTable);
        }
      }
    },

    async fn_addMember(item) {
      if (item) {
        let flag = null;
        flag = this.listMemberGroupTable.find((person) => person.id == item);
        if (flag) {
          this.membersGroup = null;
          window.toastr.warning(`Đã tồn tại người này trong nhóm`);
          return;
        } else {
          let o = this.mData.listEmployee.find(e => e.id == item);
          if (o) {
            o = await this.fn_changeData(o);
            this.listMemberGroupTable.push(o);
          }
          this.membersGroup = null;
          // console.log("listMemberGroupTable", this.listMemberGroupTable);
        }
      }
    },

    fn_deleteMember(id) {
      if (id) {
        this.listMemberGroupTable = this.listMemberGroupTable.filter(
          (person) => {
            return person.id != id;
          }
        );
      }
    },

    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.page = this.mData.tableRules.page;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-CategoryManagement-" + this.mData.moduleName,
            query: {
              ...dataFilter,
            },
          })
          .catch((err) => {
            // console.log(err);
          });
      }
      const documentGroupApiRes = await DocumentGroupApi.list(dataFilter);
      this.mData.tableRules.total = documentGroupApiRes.meta.total;
      if (documentGroupApiRes.result && documentGroupApiRes.result.length > 0) {
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
        this.mData.tableRules.data = await this.fn_changeDataDocGroup(
          documentGroupApiRes.result
        );
        // console.log('this.mData.tableRules.data', this.mData.tableRules.data);
      } else {
        this.mData.tableRules.data = [];
      }
      if (
        this.mData.tableRules.offset == this.mData.tableRules.total &&
        this.mData.tableRules.page > 1
      ) {
        this.mData.tableRules.page = this.mData.tableRules.page - 1;
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
        await this.fn_initTable();
      }
    },

    fn_changeDataDocGroup(data) {
      data.forEach((group) => {
        if (group.user_ids) {
          let arr = [];
          group.user_ids.forEach(userId => {
            this.mData.listEmployee.forEach(emp => {
              if (emp.id == userId) {
                arr.push(emp.administrative_info.name.full_name);
              }
            });
          });
          group.list_user = arr ? arr.join(', ') : '';
        }
      });
      return data;
    },

    async fn_getDataById(id) {
      const documentGroupApiRes = await DocumentGroupApi.findById(id);
      if (documentGroupApiRes.result) {
        this.mData.dataForm = documentGroupApiRes.result;
        this.listMemberGroupTable = documentGroupApiRes.result.user_ids.map(item => {
          let o = {};
          this.mData.listEmployee.forEach(emp => {
            if (emp.id == item) {
              o = {
                id: emp.id,
                administrative_info: {
                  name: {
                    full_name: emp.administrative_info.name.full_name,
                  }
                },
                job_info: [
                  {
                    position_id: emp.job_info.length > 0 && emp.job_info[0].position_id ? emp.job_info[0].position_id : '',
                    department_id: emp.job_info.length > 0 && emp.job_info[0].department_id ? emp.job_info[0].department_id : '',
                  }
                ],
              }
            }
          })
          return o;
        });
        this.listMemberGroupTable = await this.fn_changeDataUpdate(this.listMemberGroupTable);
        // console.log('this.listMemberGroupTable', this.listMemberGroupTable)
      }
    },

    async fn_changeDataUpdate(data) {
      data.forEach((user) => {
        if (user.job_info[0].position_id) {
          const position = this.mData.dataDefault.listPosition.find(pos => pos.id == user.job_info[0].position_id);
          user.job_info[0].position_name = position ? position.name : '';
        }
        if (user.job_info[0].department_id) {
          const department = this.mData.dataDefault.listDepartment.find(pos => pos.id == user.job_info[0].department_id);
          user.job_info[0].department_name = department ? department.name : '';
        }
      });
      return data;
    },

    fn_getListMemberId() {
      let listId = [];
      if (this.listMemberGroupTable.length > 0) {
        listId = this.listMemberGroupTable.map((member) => member.id);
      }
      return listId;
    },

    fn_submitForm(type) {
      this.$refs["formCreateDocGroup"].validate(async (valid) => {
        if (valid) {
          try {
            let data = this.mData.dataForm;
            data.name = data.name ? data.name.trim() : "";
            data.user_ids = this.fn_getListMemberId();
            // console.log("DATA", data);
            if (type == "create") {
              await DocumentGroupApi.create(data);
            } else if (type == "update") {
              await DocumentGroupApi.update(data);
            }
            this.fn_resetForm();
            this.listMemberGroupTable = [];
            await this.fn_initTable();
            this.viewMode = "create";
          } catch (error) {
            if (
              error.code == 500 &&
              error.result.messsage == "Exit a document category with same name"
            ) {
              this.$refs.name.focus();
              window.toastr.error("Tên danh mục đã tồn tại");
            } else if (
              error.code == 500 &&
              error.result.messsage == "Exit a document category with same code"
            ) {
              this.$refs.code.focus();
              window.toastr.error("Mã danh mục đã tồn tại");
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_handle(type, scope, row) {
      if (type == "update") {
        this.viewMode = "update";
        this.fn_resetForm();
        this.fn_getDataById(row.id);
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    async fn_delete(id) {
      await DocumentGroupApi.delete(id);
      await this.fn_initTable();
      this.fn_cancelUpdate();
    },

    fn_cancelUpdate() {
      this.fn_resetForm();
      this.listMemberGroupTable = [];
      this.viewMode = "create";
    },

    fn_resetForm() {
      this.$refs["formCreateDocGroup"].resetFields();
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(1);
    },

    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }

      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
    },

    fn_goBack() {
      this.$router.go(-1);
    },

    async fn_initDataDefault() {
      await this.fn_getListEmployee();
      await this.fn_getListPosition();
      await this.fn_getListDepartment();
    }
  },

  async created() {
    await this.fn_hashUrl();
    await this.fn_initDataDefault();
    await this.fn_initTable();
    this.changeBreadCrumb('DocumentGroup')
  },
};
</script>

<style lang="scss" scoped>
::v-deep .icon {
  cursor: pointer;
}
::v-deep .isax-trash {
  color: var(--red);
}
::v-deep .el-input-number {
  .el-input__inner {
    text-align: left;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    border: none;
    background: transparent;
    line-height: 20px !important;
  }
}
</style>
